import React from 'react';
import './App.css';
import Header from './components/header';
import Footer from './components/footer';
import Main from './components/main';
import About from './components/about';
import Divider from './components/divider';
import Location from './components/location';
import img from './images/thai-ingredients2.jpeg'
import SingleLineImageList from './components/singleLineImageList';

function App() {
  return (
    <div className="App">
      <Header/>
      <Main id="home"/>
      <About id="about"/>
      <SingleLineImageList/>
      <Location id="location"/>
      <Divider>
        <img src={img} style={{width: '100%', marginBottom: -30}}/>
      </Divider>
      <Divider text={'Thank you for visiting and supporting our small family owned restaurant!'} backgroundColor="#ff2d2d"/>
      <Footer />
    </div>
  );
}

export default App;
